import React, { useState } from 'react';
import * as S from './ModalAction.styled';
import EscapeButton from 'pages/components/EscapeButton/EscapeButton';
import Loader from 'pages/components/Loader/Loader';
import WarningAmber from '@mui/icons-material/WarningAmber';

const ModalAction = ({
  onExit,
  header,
  item,
  info,
  note,
  actionBt,
  onAct,
  hideEscape,
  actionGreen,
} : {
  onExit: Function,
  header: string,
  item: string,
  info: string,
  note?: string,
  actionBt?: string,
  onAct: Function,
  hideEscape?: boolean,
  actionGreen?: boolean,
}) => {
  const [isLoading] = useState<boolean>(false);
  return (
    <>
      {
        isLoading ? <Loader isSticky /> : (
          <S.Container>
            {!hideEscape && (
              <EscapeButton
                onClick={() => onExit()}
                isNoBorder
              />
            )}
            <S.Header>{header}</S.Header>
            {item ? <S.Entry>{item}</S.Entry> : null}
            <S.Label>{info}</S.Label>
            {
              note ? (
                <S.Note>
                  <WarningAmber />
                  <S.NoteBody>
                    <strong>Note </strong>
                    {note}
                  </S.NoteBody>
                </S.Note>
              ) : null
            }
            <S.ButtonsCont>
              <S.Button1 type="button" onClick={() => onExit()}>
                Cancel
              </S.Button1>
              <S.Button0 type="button" $green={actionGreen} onClick={() => onAct()}>
                {actionBt || 'Confirm'}
              </S.Button0>
            </S.ButtonsCont>
          </S.Container>
        )
      }
    </>
  );
};

export default ModalAction;
